import React from 'react';
// import NavbarAccessRestriction from '@organisms/navbar/navbarAccessRestriction';
import NoUserFoundModal from '@organisms/modals/noUserFoundModal';

const NoUserFound = () => {
  return (
    <>
      <NoUserFoundModal />
    </>
  );
};

export default NoUserFound;
